import { AMPLITUDE_KEY, ENV_MODE } from '../config';
import { Analytics } from './amplitude';
Analytics.init(AMPLITUDE_KEY, {
  envType: ENV_MODE,
});
export { Analytics } from './amplitude';
export { FeatureFlags } from './featureFlags';
